/**
 * @copyright       Palace Resorts
 * @description     Mensajes para 
 * @author          
 * @creationDate    
 */

 import _ from "lodash";
 import appMessages from "@/i18n/app.messages";
 
 let moduleMessages = {
     messages: {
         ESP: {
             lblTitle: "Subcontratación",
             lblsubtitle: "Proveedores",
             lblButtonSearch: "Buscar",
             lblProvider: "Proveedor",
             lblCompany: "Sociedad",
             lblSTPSRegister: "Registro STPS",
             lblEmployerRegister: "Registro Patronal",
             lblOutsourcingActivities: "Actividades de subcontratación",
             lblContract: "No. Contrato",
         },
         ENG: {
             lblTitle: "Outsourcing",
             lblsubtitle: "Provider",
             lblButtonSearch: "Search",
             lblProvider: "Provider",
             lblCompany: "Company",
             lblSTPSRegister: "STPS Register",
             lblEmployerRegister: "Employer Register",
             lblOutsourcingActivities: "Outsourcing Activities",
             lblContract: "Contract number",
         },
     },
 };
 
 export default _.merge(moduleMessages, appMessages);